// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3BLO5","deck":"styles_deck__6sgSM"};